// Map default values and configurations
export const MAP_DEFAULTS = {
  center: { lat: 42.3601, lng: -71.0589 },
  zoom: 13,
  maxZoom: 22,
  maxNativeZoom: 19,
  padding: [50, 50],
};

export const RATE_LIMITER = {
  lastCall: 0,
  minDelay: 1000, // 1 second between calls
  
  async throttle() {
    const now = Date.now();
    const timeSinceLastCall = now - this.lastCall;
    if (timeSinceLastCall < this.minDelay) {
      await new Promise(resolve => setTimeout(resolve, this.minDelay - timeSinceLastCall));
    }
    this.lastCall = Date.now();
  }
};

// Icon URLs
export const LEAFLET_ICONS = {
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
};